import axios from 'axios';
import apiConfig from '../config/apiConfig';

var _cache = null;
var _cacheTs = 0;
var CACHE_MS = 5 * 60 * 1000; // 5 minutos

var DEFAULTS = { MENU_QR: 4990, POS: 19990, RESTAURANTE: 24990 };

export function invalidarCachePlanes() {
    _cache = null;
    _cacheTs = 0;
}

/**
 * Retorna un mapa { MENU_QR: precio, POS: precio, RESTAURANTE: precio }.
 * Cachea el resultado 5 minutos. Si el backend falla, retorna los defaults.
 */
export async function obtenerPreciosPlanes() {
    if (_cache && (Date.now() - _cacheTs < CACHE_MS)) {
        return _cache;
    }
    try {
        var res = await axios.get(apiConfig.api_url + '/api/planes/precios');
        if (res.data && res.data.status === 'success' && res.data.planes) {
            var mapa = {};
            res.data.planes.forEach(function(p) {
                mapa[p.plan_key] = p.precio;
            });
            _cache = mapa;
            _cacheTs = Date.now();
            return mapa;
        }
    } catch (e) {
        // Falla silenciosa: devuelve defaults sin cachear para reintentar pronto
    }
    return Object.assign({}, DEFAULTS);
}
